export default __webpack_public_path__ + "static/top_point_img_003-d2204ed7f997bce65f056e040442475d.jpg";